module.exports = __webpack_public_path__ + "static/img/bola_branca.3112f0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bola_branca.png
// module id = rwHo
// module chunks = 2